import { PayloadAction } from "@reduxjs/toolkit";
import { omit } from "lodash";
import { BirthInfo } from "../types/birth-info.ts";
import { Personal } from "../types/personal.ts";
import { CustomerState } from "../customer.slice.ts";
import { FamilyInfo } from "../types/family.ts";
import { FiscalCodeRequest } from "../../../../orchestrator-api-client";

export const personalInfoReducer = (
  state: CustomerState,
  action: PayloadAction<Partial<Personal>>,
) => {
  const { firstName, lastName, gender } = action.payload;
  state.personalInfo.firstName = firstName!;
  state.personalInfo.lastName = lastName!;
  state.personalInfo.gender = gender!;
};

type BirthInfoReducerType = BirthInfo | Partial<Pick<Personal, "nationality">>;

export const birthInfoReducer = (
  state: CustomerState,
  action: PayloadAction<BirthInfoReducerType>,
) => {
  if ("nationality" in action.payload) {
    state.personalInfo.nationality = action.payload.nationality!;
  }
  state.birth = omit(action.payload, "nationality") as BirthInfo;
};

export const familyStatusReducer = (
  state: CustomerState,
  action: PayloadAction<Omit<FamilyInfo, "maritalStatus">>,
) => {
  state.family = {
    ...state.family,
    ...action.payload,
  };
};

export const fiscalCodeReducer = (
  state: CustomerState,
  action: PayloadAction<FiscalCodeRequest>,
) => {
  state.personalInfo.fiscalCode = action.payload.fiscalCode!;
  if (
    action.payload.birthDate &&
    action.payload.birthProvince &&
    action.payload.birthCity &&
    action.payload.gender
  ) {
    const [birthYear, birthMonth, birthDay] =
      action.payload.birthDate.split("-");
    state.birth = {
      ...state.birth,
      birthDate: {
        birthDay: Number(birthDay),
        birthMonth: Number(birthMonth),
        birthYear: Number(birthYear),
      },
      birthCity: action.payload.birthCity!,
      birthProvince: action.payload.birthProvince!,
    };
    state.personalInfo.gender = action.payload.gender!;
  }
};
